const interceptor = (requestConfig, cloudflareUrl) => {
  const transformedConfig = requestConfig;

  transformedConfig.baseURL = cloudflareUrl;

  return transformedConfig;
};

export default interceptor;
